export default "__VITE_ASSET__BiFwY4Tw__"